import { initialize } from 'redux-form'
import moment from 'moment'
import { getUser } from 'Common'
import modalProps from '../modalProps'
import { FORM_NAME } from '../Form'

export default () => (dispatch) => {
  
  const { subOrder, subcontractorId, projectId, retentionPercentage } = modalProps()

  if (subOrder) {

    // Ensure approved_by is set as the user ID (not the user object)
    // The API may return approved_by as an object (when relationship is loaded) or as an ID
    let approvedById = subOrder.approved_by
    if (subOrder.approved_by && typeof subOrder.approved_by === 'object') {
      approvedById = subOrder.approved_by.id
    }

    const formData = {
      ...subOrder,
      approved_by: approvedById,
    }

    dispatch(initialize(FORM_NAME, formData))
    
  } else {

    dispatch(initialize(FORM_NAME, {
      subcontractor_id: subcontractorId,
      project_id: projectId,
      user_id: getUser().id,
      date: moment().format('YYYY-MM-DD'),
      vat_perc: 20,
      retention_percentage: retentionPercentage || null,
    }))

  }

}
